import React, { useState } from 'react';
import ApplicationFormFields from './ApplicationFormFields';

const CourseApplicationForm = ({ courseName, courseValue, onApplyClick }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: courseValue,
    specialization: '',
    employment_status: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Course form submitted:', formData);
    // Here you would typically send the data to your backend
    alert('Application submitted successfully!');
    onApplyClick();
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      course: courseValue,
      specialization: '',
      employment_status: ''
    });
  };

  return (
    <div className="shadow-sm rounded border overflow-hidden mb-4">
      <h5 className="bg-primary bg-opacity-10 textprimary fw-bold p-2 p-lg-3">Quick Facts</h5>
      <div className="px-3 px-lg-4">
        <div className="sidebar-form">
          <div className="heading text-center">
            <p className="mb-1">APPLY TODAY FOR</p>
            <h3 className="fs-5 text-danger">Mewar University Programs</h3>
          </div>
          <ApplicationFormFields 
            formData={formData}
            onInputChange={handleInputChange}
            onSubmit={handleSubmit}
            submitButtonText="Apply Now"
            showPrivacyNote={false}
            className="mt-3"
          />
        </div>
      </div>
    </div>
  );
};

export default CourseApplicationForm;